import { useCallback } from 'react';
import { useStoreState } from 'easy-peasy';
import { 
  PRODUCTS, 
  ACCESSLEVEL, 
  hasCheckpointSettingsMenuAccess,
  hasPolicySettingsMenuAccess, 
  hasMainAppSettingsMenuAccess,
  hasAutoAuthSettingsMenuAccess,
} from '../constants/applicationConstants';

const userProductRoleData = (userInfoData, product) => {
  return product === PRODUCTS.MAINAPP ? userInfoData?.roles : userInfoData?.permissions?.[product];
}

const userProductOBJ = (userInfoData, product) => {  
  return userInfoData?.products?.filter((item) => item.code === product )?.[0];
}

function useCommonAuth() {
  const userInfo = useStoreState((state) => state.login.userInfo);

  // User have product access hook
  const isProductAccess = useCallback((product) => {
    const userProductPermissions = userProductOBJ(userInfo, product);
    if(userProductPermissions) {
      return true;
    }
    return false;
  });
  
  // User have package hook
  const hasPackage = useCallback((product, item) => {
    if (!userInfo || userInfo === null) return false;
    const userProductPermissions = userProductOBJ(userInfo, product);
    if(userProductPermissions && userProductPermissions.addons) {
      return userProductPermissions?.addons?.includes(item);
    } else {
      return false;
    }
  });

  // User have module permissions hook
  const userModulePermissions = useCallback((path, accessLevel, product = null) => {
    if (!userInfo || userInfo === null) return false;
    const userProductPermissions = userProductRoleData(userInfo, product);
    let userAccessList = userProductPermissions?.access;
    const doesExists = userAccessList?.find((item) => {
      if (item.path === path && item['access_level'].includes(accessLevel)) {
        return item;
      }
    });
    
    return (!!doesExists);
  });

  // Setting menu access hook
  const hasSettingsMenuAccess = useCallback((product, role) => {
    if(role && product === PRODUCTS.CHECKPOINT) {
      return hasCheckpointSettingsMenuAccess.includes(role?.toLowerCase());  
    } else if(role && product === PRODUCTS.POLICIES) {
      return hasPolicySettingsMenuAccess.includes(role?.toLowerCase());
    } else if(role && product === PRODUCTS.MAINAPP) {
      return hasMainAppSettingsMenuAccess.includes(role?.toLowerCase());
    } else if(role && product === PRODUCTS.AUTO_AUTH) { console.log("Hii", product, role);
      return hasAutoAuthSettingsMenuAccess.includes(role?.toLowerCase());
    } else {
      return false;
    }    
  });

  // Product access level full/limited
  const isFullProductAccessLevel = useCallback((product) => {
    const userProductPermissions = userProductOBJ(userInfo, product);
    if(userProductPermissions && userProductPermissions?.accesslevel && userProductPermissions?.accesslevel?.toLowerCase() === ACCESSLEVEL.FULL) {
      return true;
    }
    return false;
  });

  return {isProductAccess, hasPackage, userModulePermissions, hasSettingsMenuAccess, isFullProductAccessLevel};
}

export default useCommonAuth;
